import updateBookingStatus from './updateBookingStatus';
import getAllStatuses from './getAllStatuses';

export default {
  updateBookingStatus,
  getAllStatuses,
}



// WEBPACK FOOTER //
// ./src/app/services/booking_status/index.js